/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import { KahuIcons } from '@/components/icons/icons';

import { PreviewRow } from './preview-row';
import { PromptListLinkProps } from './prompt-list';
import { PromptBlock } from './prompt-list-utils';
import { TraceIdLink } from './trace-id-link';

export const PromptCard = function ({
  block,
  index,
  onOpen,
  messageId,
  copiedInfo,
  setCopiedInfo,
}: {
  block: PromptBlock;
  index: number;
  onOpen: () => void;
} & PromptListLinkProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpen();
        }
      }}
      className="group flex w-full cursor-pointer flex-col gap-2"
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-body-sm text-body-subtle">
          <span className="text-body font-bold text-[#EBEFF1]">
            {index + 1}. Trace ID{' '}
          </span>
          <TraceIdLink
            block={block}
            occurrenceKey={`${messageId}:prompt-card:${index}`}
            copiedInfo={copiedInfo}
            setCopiedInfo={setCopiedInfo}
          />
        </span>
      </div>
      <div
        className="relative flex flex-col gap-3 rounded bg-[#0000007A] pb-4
        pl-3 pr-2 pt-2"
      >
        <span className="absolute right-2 top-2 text-[#8C9EA1]">
          {KahuIcons.MaximizeIcon('w-5 h-5')}
        </span>
        <div className="flex flex-col gap-3">
          <PreviewRow label="Input" text={block.input} />
          <PreviewRow label="Output" text={block.output} />
        </div>
      </div>
    </div>
  );
};
